import React from 'react';
import { IconProps } from './types';

const Check: React.FC<IconProps> = ({
  className,
  color = '#181B32',
  size = 32,
  ignoreColor,
}) => (
  <svg
    className={className}
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    width={size * 1.25}
    height={size}
    viewBox="0 0 40 32"
  >
    <path
      fill={!ignoreColor ? color : undefined}
      d="M38.75 1.5v0c-2-2-5.225-2-7.225 0 0 0 0 0 0 0l-18.175 18.175-4.625-4.625c-2-2-5.225-2-7.225 0s-2 5.225 0 7.2l8.225 8.25c2 1.975 5.225 1.975 7.225 0l21.8-21.775c1.975-2 1.975-5.225 0-7.225 0 0 0 0 0 0z"
    />
  </svg>
);

export default Check;
